/**!
 * Created by Leonardo Cheslacki on 25/08/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import HelpersController from './HelpersController';

import WithType from './../WithType';

let _this = {};

/**
 *
 */
class HelpersPin extends HelpersController {

    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        _this = this;
    };

    /**
     *
     * @param occ_text
     * @param string
     * @param color
     * @param font
     * @param size
     * @param weight
     * @param x
     * @param y
     * @param capitalize
     * @param upper_case
     */
    setText = (occ_text, string, color, font, size, weight, x = null, y = null, capitalize = true, upper_case = false) => {
        if (!this.isEmpty(string) && this.verifyField(occ_text, 'text')) {
            let text = (capitalize ? this.toCapitalize(string) : string);
            occ_text.text = upper_case ? text.toUpperCase() : text;
        }
        if (this.isTintColor(color) && this.verifyField(occ_text, 'color')) {
            occ_text.color = this.tintToHex(color);
        }
        if (!this.isEmpty(font) && this.isInteger(size) && this.verifyField(occ_text, 'font')) {
            occ_text.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
        }
        x = this.toIntegerOrFloat(x);
        if (this.isIntegerOrFloat(x) && this.verifyField(occ_text, 'x')) {
            occ_text.x = x;
        }
        y = this.toIntegerOrFloat(y);
        if (this.isIntegerOrFloat(y) && this.verifyField(occ_text, 'y')) {
            occ_text.y = y;
        }
    };

    /**
     *
     * @param occ_pin_number
     * @param number
     * @param x
     * @param y
     * @param color
     * @param font
     * @param size
     * @param weight
     */
    setNumber = (occ_pin_number, number, x, y, color = null, font = null, size = null, weight = null) => {
        if (this.isIntegerOrFloat(number) && this.verifyField(occ_pin_number, 'text')) {
            occ_pin_number.text = this.padWithLeadingZeros(number, 2);
        } else if (number === 'null') {
            occ_pin_number.visible = false;
        } else {
            occ_pin_number.text = number.toUpperCase();
        }
        if (this.isTintColor(color) && this.verifyField(occ_pin_number, 'color')) {
            occ_pin_number.color = this.tintToHex(color);
        }
        if (!this.isEmpty(font) && this.isInteger(size) && this.verifyField(occ_pin_number, 'font')) {
            occ_pin_number.font = `${(!this.isEmpty(weight) ? `${weight.toLowerCase()} ` : ``)}${size}px '${font}'`;
        }
        x = this.toIntegerOrFloat(x);
        if (this.isIntegerOrFloat(x) && this.verifyField(occ_pin_number, 'x')) {
            occ_pin_number.x = x;
        }
        y = this.toIntegerOrFloat(y);
        if (this.isIntegerOrFloat(y) && this.verifyField(occ_pin_number, 'y')) {
            occ_pin_number.y = y;
        }
    };

    /**
     *
     * @param occ_color
     * @param color
     */
    setColor = (occ_color, color) => {
        const execute = (shape) => {
            if (!this.isEmpty(shape) && this.isTintColor(color)) {
                if (this.verifyField(shape, 'graphics._fill.style')) {
                    shape.graphics._fill.style = this.tintToHex(color);
                } else if (this.verifyField(shape, 'graphics._stroke.style')) {
                    shape.graphics._stroke.style = this.tintToHex(color);
                }
            }
        };

        let
            shape = this.verifyField(occ_color, 'shape'),
            shape_1 = this.verifyField(occ_color, 'shape_1');

        shape && execute(shape);
        shape_1 && execute(shape_1);
    };

    /**
     *
     * @param object
     * @param x
     * @param y
     */
    setCoordinate = (object, x, y) => {
        x = this.toIntegerOrFloat(x);
        y = this.toIntegerOrFloat(y);
        this.isIntegerOrFloat(x) && (object.x = x);
        this.isIntegerOrFloat(y) && (object.y = y);
    };

    /**
     *
     * @param occ_effect
     * @param visible
     */
    setAnimate = (occ_effect, visible) => {
        occ_effect.visible = visible;
    };

    /**
     *
     * @param _this
     * @param object
     * @param enabled
     * @param cursor
     */
    setCursor = (_this, object, enabled, cursor) => {
        object.mouseEnabled = enabled;
        !this.isEmpty(cursor) && (object.cursor = cursor);
    };

    /**
     *
     * @param _this
     * @param object
     * @param enabled
     * @param cursor
     * @param uri
     */
    setAction = (_this, object, enabled, cursor, uri) => {
        this.setCursor(_this, object, enabled, cursor);
        !this.isEmpty(uri) && _this.setStateOccurrence(object, {uri: uri});
    };
}

/**
 *
 * @type {{}}
 */
HelpersPin.propTypes = {};

/**
 *
 * @type {{}}
 */
HelpersPin.defaultProps = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(HelpersPin, {className: 'HelpersPin'});
